import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionCoopCollectPointsResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopCollectPoints = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.CollectCoopPoints), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.CollectCoopPoints,
            props: {
                coopId: action.coopId,
                playerId: action.playerId,
            },
        });
    }), switchMap(function (res) {
        var rewardItem = {
            amount: res.amount,
            typeId: res.itemId,
        };
        return from([
            actionAddPelletsInScreenCenterAnimation(1, [
                {
                    amount: rewardItem.amount || 0,
                    icon: getResourceIconInfo(rewardItem).icon,
                },
            ]),
            actionInventoryInfoAddResource([rewardItem]),
            actionCoopCollectPointsResponse(),
        ]);
    }), retry());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopCollectPoints.ts
// module id = 1799
// module chunks = 3